import { format } from "date-fns";
import { staticText } from "../statics/static-text";

const DATE_TIME_FORMAT = "MMM dd, yyyy HH:mm";

export const formatDateTime = (
  date?: string | null,
  formatOverride?: string,
) =>
  date
    ? format(new Date(date), formatOverride ?? DATE_TIME_FORMAT)
    : staticText.shared.emptyValue;
